export default {
  "dismiss": "Dismiss",
  "confirm": "Confirm",
  "loading": "Loading...",
  "retry": "Retry now",
  "cancel": "Cancel",
  "close": "Close",
  "back": "Back",
  "save": "Save",
  "saving": "Saving…",
  "automatic": "Automatic",
  "settings": "Settings",
  "support": "Ask support",
  "sign_out": "Sign out",
  "sessions_one": "{{count}} session",
  "sessions_other": "{{count}} sessions",
  "servers_one": "{{count}} server",
  "servers_other": "{{count}} servers"
} as const;
